var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5034 18.0185C10.9504 16.7647 11.6011 15.6472 12.4046 14.7254C14.881 11.8842 19.548 13.0476 20.3532 16.7285C20.455 17.1903 20.5093 17.675 20.5093 18.1746C20.5093 21.3921 18.2678 24 15.5039 24H9.03263H5.49466H0.489258V18.1746V5.8254V0H5.49466H9.63738H15.5055C18.2695 0 20.5109 2.60788 20.5109 5.8254C20.5109 6.32167 20.4567 6.80479 20.3564 7.26491C19.5529 10.9458 14.8843 12.1126 12.4063 9.27299C11.6044 8.3544 10.9553 7.24026 10.5083 5.99137L10.5034 5.97823V5.97658L10.4771 5.90099C10.1714 5.02184 9.96603 4.07696 9.87729 3.08771L9.82634 2.52078L9.7721 3.20438C9.40072 7.84827 6.43297 11.5588 2.62387 12.1421L2.1572 12.2128C6.23416 12.53 9.49768 16.4393 9.81976 21.3855L9.82634 21.4809L9.87565 20.9189C9.96603 19.9 10.1797 18.9289 10.5001 18.0283L10.5034 18.0185ZM10.0465 9.16638H10.0645C10.2174 10.5697 11.5107 11.8449 12.9272 11.9846V12.001V12.0125C11.4959 12.1391 10.2174 13.4192 10.0645 14.8357H10.0465H10.0449C9.92653 13.3567 8.73186 12.1604 7.23977 12.0651V12.0437C8.63327 11.8696 9.89201 10.5549 10.0268 9.16638H10.0465Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLogo);
export default __webpack_public_path__ + "static/media/home-logo.8a306b26d70b34f98e9bf73df28a4433.svg";
export { ForwardRef as ReactComponent };